import { Box } from "@mui/material";

import FormerlyLicenseLead from "../assets/images/formerly-licenselead.png";
import { default as ScaleIPLogo } from "../assets/images/scaleIP-logo.svg?react";
import C from "../constants/constants";

export default function AuthLogos() {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: {
          sm: "row",
          xs: "column",
        },
        gap: {
          sm: 4,
          xs: 2,
        },
        justifyContent: "center",
      }}
    >
      <a aria-label="ScaleIP Website" href={C.VITE_APP_WEBSITE}>
        <ScaleIPLogo style={{ height: "auto", width: 240 }} />
      </a>
      <img alt="Formerly LicenseLead Logo" src={FormerlyLicenseLead} width="124" />
    </Box>
  );
}
